const STORAGE_KEY = "redirectAfterLogin";

export const redirectManager = {
    save(path: string) {
        if (path && path !== "/" && path !== "/login" && path !== "/register") {
            sessionStorage.setItem(STORAGE_KEY, path);
        }
    },

    consume(): string | null {
        const path = sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return path;
    },
};
